// Load Styles
import '../scss/main.scss';

// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";
import "jquery-validation";
import moment from "moment-timezone";

// Loading bootstrap with optional features
initBootstrap({});

if ($(window).scrollTop() > 34) {
  $(".navbar").addClass("sticky-nav");
} else {
  $(".navbar").removeClass("sticky-nav");
}

$(window).on("scroll", function() {
  var scrollTop = $(window).scrollTop();
  if (scrollTop > 34) {
    $(".navbar").addClass("sticky-nav");
  } else {
    $(".navbar").removeClass("sticky-nav");
  }
});

$('#showPassword').click(function(e) {
  e.preventDefault();

  if($('#password').attr('type') == 'password') {
      $('#password').prop('type', 'text');
      $(this).find('i').removeClass('fa-eye').addClass('fa-eye-slash');
  } else {
       $('#password').prop('type', 'password');
       $(this).find('i').removeClass('fa-eye-slash').addClass('fa-eye');
  }
}); 


$.validator.setDefaults({
    errorElement: 'div',
    errorClass: 'is-invalid',
    errorPlacement: function(error, element) {
      element.addClass('is-invalid');
      var feedback = $('<div>').addClass('invalid-feedback').html(error);
      feedback.appendTo(element.parent());
    },
    highlight: function(element) {
      $(element).addClass('is-invalid');
    },
    unhighlight: function(element) {
      $(element).removeClass('is-invalid');
    },
});

// Validate login form
$('#login-form').validate({
  rules: {
    email: {
      required: true,
      email: true
    },
    password: {
      required: true,
    }
  },
  messages: {
    email: {
      required: "Please enter your email address *",
      email: "Please enter a valid email address *"
    },
    password: {
      required: "Please enter your password *"
    }
  },
});

$("#register-form").on("submit", function(event) {
  event.preventDefault();
  grecaptcha.execute();
});

// Validate register form
var validator = $('#register-form').validate({
  rules: {
    name: {
      required: true,
    },
    email: {
      required: true,
      email: true
    },
    password: {
      required: true,
      minlength: 8
    },
    password_confirmation: {
      required: true,
      equalTo: "#password"
    },
    terms: {
      required: true,
    }
  },
  messages: {
    name: {
      required: "Please enter your name *",
    },
    email: {
      required: "Please enter your email address *",
      email: "Please enter a valid email address *"
    },
    password: {
      required: "Please enter your password *",
      minlength: "Password must be at least 8 characters long *"
    },
    password_confirmation: {
      required: "Please enter your password confirmation *",
      equalTo: "Password confirmation does not match *"
    },
    terms: {
      required: "Please accept our terms and conditions *",
    }
  },
  submitHandler: function(form) {
    // check if reCAPTCHA is valid
    if(!grecaptcha.getResponse()) {
      return false;
    } else {
      form.submit();
    }
    
    return false;
  }
});

var timezone = moment.tz.guess();

$('.timezone').val(timezone);

// Callback function for reCAPTCHA
function onSubmit(token) {
  validator.form();
}

// Set the global reCAPTCHA callback
window.onSubmit = onSubmit;